var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeader = function SvgHeader(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510.76 138.39",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea5504;}.cls-2{fill:#ed6c00;}.cls-3{fill:#f08300;}.cls-4{fill:#f39800;}.cls-5{fill:#f6ab00;}.cls-6{fill:#fabe00;}.cls-7{fill:#fdd000;}.cls-8{fill:#404040;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u30A2\u30BB\u30C3\u30C8 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 98.15 39.27 137.41 39.27 58.89 0 98.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.27 58.9 78.52 19.64 0.01 19.64 39.27 58.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.01 98.16 0.01 137.41 39.27 137.41 0.01 98.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150.32 137.41 122.56 109.64 94.8 137.41 150.32 137.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.01 19.64 0.01 98.15 39.27 58.89 0.01 19.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "58.9 39.27 137.41 39.27 98.15 0.01 58.9 39.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "109.66 67.03 109.65 94.79 137.41 67.03 109.66 67.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "94.8 109.65 94.79 137.41 122.56 109.64 94.8 109.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 109.65,
    y: 39.26,
    width: 27.76,
    height: 27.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "67.03 81.89 67.04 109.65 94.8 109.65 94.8 81.89 67.03 81.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "67.03 81.89 39.27 109.64 67.03 109.65 67.03 81.89 67.03 81.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "122.56 109.64 94.8 81.89 94.8 109.64 122.56 109.64 122.56 109.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "58.89 0 58.89 0 19.63 0 0 19.62 39.26 19.63 58.89 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "98.15 0.01 98.15 0.01 58.9 0.01 39.26 19.63 78.52 19.64 98.15 0.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.91,69.56c0-17.22-11.89-28.79-29.59-28.79H177.68v96.82H194V97.83h15.31l19.24,39.76H247.5L226.22,95.36C237.33,91.61,243.91,82.07,243.91,69.56ZM213.29,83.17H194V56.09h19.29c8.82,0,14.3,5.21,14.3,13.61S222.11,83.17,213.29,83.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M303.66,40a33.46,33.46,0,0,0-24.88,10.44c-9.2,9.51-9.2,20.24-9.2,38v1.51c0,17.78,0,28.5,9.2,38a35,35,0,0,0,49.89,0c9.08-9.38,9.08-19.89,9.07-37.3V87.71c0-17.41,0-27.92-9.07-37.3A33.61,33.61,0,0,0,303.66,40Zm12.68,77.67a17.55,17.55,0,0,1-25.36,0c-4.17-4.68-5.07-9.74-5.07-28.47s.9-23.78,5.07-28.47a17.54,17.54,0,0,1,25.36,0c4.18,4.69,5.08,9.74,5.08,28.47S320.52,113,316.34,117.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "510.76 56.09 510.76 40.77 449.91 40.77 449.91 137.59 510.76 137.59 510.76 122.27 466.24 122.27 466.24 96.38 502.13 96.38 502.13 81.19 466.24 81.19 466.24 56.09 510.76 56.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M410.62,106.74c-.69,5.41-2,8.22-4.39,10.9a17.57,17.57,0,0,1-25.37,0c-4.17-4.68-5.08-9.74-5.08-28.47s.91-23.78,5.08-28.47a17.55,17.55,0,0,1,25.37,0c2.31,2.59,3.61,5.31,4.32,10.41h16.63c-.76-8.34-2.87-14.75-8.63-20.71a35,35,0,0,0-49.89,0c-9.2,9.51-9.2,20.24-9.2,38v1.51c0,17.78,0,28.5,9.2,38a35,35,0,0,0,49.89,0c5.88-6.07,7.94-12.62,8.67-21.2Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/header.0d140ac6200bc03fb864113ffc14dac3.svg";